// Constants

export const multiple_servicios = () => {
  return {
    multiple_servicios: {
      id: {
        namepath: ['afiliacion_nueva','afiliado_crear','servicios_afiliacion','informes_afiliaciones','afiliado_ficha','afiliacion_servicios','admin_servicios','aportes_registrar','servicios_aportes','aportes_cuentas','archivo_retiros'],
        description: 'id autoincrement',
        label: 'Id',
        readonly: true,
        type: 'number',
        datatype: 
        {
          predeterminate: ''
        }
      },
      id_datos_afiliado: {
        namepath: ['afiliacion_nueva','afiliado_crear','servicios_afiliacion','informes_afiliaciones','afiliado_ficha','afiliacion_pendientes','afiliacion_servicios','admin_servicios','aportes_registrar','servicios_aportes','aportes_cuentas','archivo_retiros'],
        description: 'id afiliado',
        label: 'Id afiliado',
        readonly: true,
        type: 'number',
        datatype: { 
          type: 'text', 
          disabled: false,
          value: '',
          predeterminate: '',
        }
      },
      id_info_afiliacion: {
        type: "number",
        label: "Afiliado",
        placeholder: "",
        namepath: ['afiliacion_nueva','afiliado_crear','servicios_afiliacion','informes_afiliaciones','afiliado_ficha','afiliacion_servicios','admin_servicios','aportes_registrar','servicios_aportes','aportes_cuentas','archivo_retiros'],
        description: "",
        validate: "",
        datatype: {
          type: "input",
          disabled: false,
          predeterminate: "",
        }
      },
      id_afiliacion_registro: {
        namepath: ['afiliacion_nueva','afiliado_crear','servicios_afiliacion','informes_afiliaciones','afiliado_ficha','afiliacion_servicios','admin_servicios','aportes_registrar','servicios_aportes','aportes_cuentas','archivo_retiros'],
        description: 'id afiliacion_registro',
        label: 'Id afiliado',
        readonly: true,
        type: 'number',
        datatype: { 
          type: 'text', 
          disabled: false,
          value: '',
          predeterminate: '',
        }
      },
      id_info_ingresos: {
        namepath: ['afiliacion_nueva','afiliado_crear','servicios_afiliacion','informes_afiliaciones','afiliado_ficha','afiliacion_servicios','admin_servicios','aportes_registrar','servicios_aportes','aportes_cuentas','archivo_retiros'],
        description: 'id afiliacion_registro',
        label: 'Id afiliado',
        readonly: true,
        type: 'number',
        datatype: { 
          type: 'text', 
          disabled: false,
          value: '',
          predeterminate: '',
        }
      },
      name: {
        namepath: ['afiliacion_nueva','afiliado_crear','servicios_afiliacion','informes_afiliaciones','afiliado_ficha','afiliacion_servicios','admin_servicios','aportes_registrar','servicios_aportes','aportes_cuentas','archivo_retiros'],
        type: 'text',
        label: 'Nombre del Servicio',
        placeholder: '',
        description: 'Nombre del check', 
        validate: 'required',
        datatype: { 
          type: 'input', 
          disabled: false,
          predeterminate: '',
        }   
      }, 
      id_list: {
        namepath: ['afiliacion_nueva','afiliado_crear','servicios_afiliacion','informes_afiliaciones','afiliado_ficha','afiliacion_servicios','admin_servicios','aportes_registrar','servicios_aportes','aportes_cuentas','archivo_retiros'],
        type: 'select',
        label: 'Entidad',
        placeholder: '',
        description: 'Entidad',
        validate: '',
        datatype: { 
          type: 'select', 
          disabled: false,
          predeterminate: 1,
          list: 'list_',
          label: 'name'
        }
      },
      name_list:{
        namepath: ['afiliacion_nueva','afiliado_crear','servicios_afiliacion','informes_afiliaciones','afiliado_ficha','afiliacion_servicios','admin_servicios','aportes_registrar','servicios_aportes','aportes_cuentas','archivo_retiros'],
        type: 'text',
        label: 'Name list',
        readonly: true,
        validate: '',
        description: 'Nombre de la lista',
        datatype:{
          predeterminate: ''
        }  
      },
      iniciolabores: {
        namepath: ['afiliacion_nueva','afiliado_crear','servicios_afiliacion','informes_afiliaciones','afiliado_ficha','afiliacion_servicios','admin_servicios','aportes_registrar','servicios_aportes','aportes_cuentas','archivo_retiros'],
        type: 'text',
        label: 'Inicio labores',
        placeholder: '',
        description: 'Fecha de inicio de labores',
        validate: '',
        datatype: 
        {
          type: 'date',
          disabled: false,
          predeterminate: '',
        }
      },
      retiro: {
        namepath: ['afiliacion_nueva','afiliado_crear','servicios_afiliacion','informes_afiliaciones','afiliado_ficha','afiliacion_servicios','admin_servicios','aportes_registrar','servicios_aportes','aportes_cuentas','archivo_retiros'],
        type: 'text',
        label: 'Fecha retiro',
        placeholder: '',
        description: 'Fecha de retiro',
        validate: '',
        datatype: 
        {
          type: 'date',
          disabled: false,
          predeterminate: '',
        }
      },
      mes_periodo: {
        namepath: ['afiliacion_nueva','afiliado_crear','servicios_afiliacion','informes_afiliaciones','afiliado_ficha','afiliacion_servicios','admin_servicios','aportes_registrar','servicios_aportes','aportes_cuentas','archivo_retiros'],
        type: 'texxt',
        label: 'Mes',
        placeholder: '',
        description: 'Próximo mes a cobrar',
        validate: '',
        datatype: { 
          type: 'select', 
          disabled: false,
          value: '1',
          predeterminate: '',
          list: 'list_mes',
          label: 'name'
        }
      },
      ano_periodo: {
        namepath: ['afiliacion_nueva','afiliado_crear','servicios_afiliacion','informes_afiliaciones','afiliado_ficha','afiliacion_servicios','admin_servicios','aportes_registrar','servicios_aportes','aportes_cuentas','archivo_retiros'],
        type: 'select',
        label: 'Año',
        placeholder: '',
        description: 'Próximo año a cobrar',
        validate: '',
        datatype: { 
          type: 'select', 
          disabled: false,
          value: '1',
          predeterminate: '',
          list: 'list_ano',
          label: 'name'
        }
      },
      archivo: {
        namepath: ['afiliacion_servicios','admin_servicios','aportes_registrar','servicios_aportes','aportes_cuentas','archivo_retiros'],
        type: 'text',
        label: 'Archivo',
        placeholder: '',
        description: 'Nombre del archivo a cargar',
        validate: '',
        datatype: 
        {
          type: 'file',
          disabled: false,
          value: '',
          predeterminate: null,
        }
      },
      afiliacion: {
        namepath: ['afiliacion_nueva','afiliado_crear','servicios_afiliacion','informes_afiliaciones','afiliado_ficha','afiliacion_servicios','admin_servicios','aportes_registrar','servicios_aportes','aportes_cuentas','archivo_retiros'],
        type: 'number',
        label: 'Afiliación',
        placeholder: '',
        description: 'Valor de afiliación',
        validate: '',
        datatype: 
        {
          type: 'price',
          disabled: false,
          predeterminate: 0,
          prepend: '$',
          append: '',
        }
      }, 
      valoringreso: {
        namepath: ['afiliacion_nueva','afiliado_crear','servicios_afiliacion','informes_afiliaciones','afiliado_ficha','afiliacion_servicios','admin_servicios','aportes_registrar','servicios_aportes','aportes_cuentas','archivo_retiros'],
        type: 'number',
        label: 'Valor',
        placeholder: '',
        description: 'Valor del servicio',
        validate: '',
        datatype: 
        {
          type: 'price',
          disabled: false,
          predeterminate: 0,
          prepend: '$',
          append: '',
        }
      },
      valor: {
        namepath: ['afiliacion_nueva','afiliado_crear','servicios_afiliacion','informes_afiliaciones','afiliado_ficha','afiliacion_servicios','admin_servicios','aportes_registrar','servicios_aportes','aportes_cuentas','archivo_retiros'],
        type: 'number',
        label: 'Valor',
        placeholder: '',
        description: 'Valor del servicio',
        validate: '',
        datatype: 
        {
          type: 'price',
          disabled: false,
          predeterminate: 0,
          prepend: '$',
          append: '',
        }
      },
      valorretiro: {
        namepath: ['afiliacion_nueva','afiliado_crear','servicios_afiliacion','informes_afiliaciones','afiliado_ficha','afiliacion_servicios','admin_servicios','aportes_registrar','servicios_aportes','aportes_cuentas','archivo_retiros'],
        type: 'number',
        label: 'Valor',
        placeholder: '',
        description: 'Valor del servicio',
        validate: '',
        datatype: 
        {
          type: 'price',
          disabled: false,
          predeterminate: 0,
          prepend: '$',
          append: '',
        }
      },
      porcentaje: {
        namepath: ['afiliacion_nueva','afiliado_crear','servicios_afiliacion','informes_afiliaciones','afiliado_ficha','afiliacion_servicios','admin_servicios','aportes_registrar','servicios_aportes','aportes_cuentas','archivo_retiros'],
        type: 'text',
        label: 'Porcentaje',
        placeholder: '',
        description: 'valor en Porcentajes',
        validate: 'required',
        datatype: 
        {
          type: 'input',
          disabled: false,
          value:  '',
          predeterminate: '',
          prepend: '',
          append: '',
        }
      },
      observacion: {
        namepath: ['afiliacion_nueva','afiliado_crear','servicios_afiliacion','informes_afiliaciones','afiliado_ficha','afiliacion_servicios','admin_servicios','aportes_registrar','servicios_aportes','aportes_cuentas','archivo_retiros'],
        type: 'text',
        label: 'Observación',
        placeholder: '',
        description: 'Observacion al servicio',
        validate: '',
        datatype: 
        {
          type: 'input',
          disabled: false,
          value: '',
          predeterminate: '',
        }
      },
      check: {
        namepath: ['afiliacion_nueva','afiliado_crear','servicios_afiliacion','informes_afiliaciones','afiliado_ficha','afiliacion_servicios','admin_servicios','aportes_registrar','servicios_aportes','aportes_cuentas','archivo_retiros'],
        type: 'boolean',
        label: 'Selec.',
        placeholder: '',
        description: 'Subtipo de cotizante',
        validate: 'required',
        datatype: { 
          type: 'check', 
          disabled: false,
          predeterminate: 0,
        }
      },
      lock: {
        namepath: ['afiliacion_nueva','afiliado_crear','servicios_afiliacion','informes_afiliaciones','afiliado_ficha','afiliacion_servicios','admin_servicios','aportes_registrar','servicios_aportes','aportes_cuentas','archivo_retiros'],
        description: 'si es visible',
        label: 'View',
        readonly: true,
        type: 'boolean',
        datatype: 
        {
          type: 'check', 
          disabled: false,
          predeterminate: 0,
        }
      },
      disabled: {
        namepath: ['afiliacion_nueva','afiliado_crear','servicios_afiliacion','informes_afiliaciones','afiliado_ficha','afiliacion_servicios','admin_servicios','aportes_registrar','servicios_aportes','aportes_cuentas','archivo_retiros'],
        description: 'si es deshabilitado',
        label: 'Disabled',
        readonly: true,
        type: 'boolean',
        datatype: 
        {
          type: 'check', 
          disabled: false,
          predeterminate: 0,
        }
      },
      view: {
        namepath: ['afiliacion_nueva','afiliado_crear','servicios_afiliacion','informes_afiliaciones','afiliado_ficha','afiliacion_servicios','admin_servicios','aportes_registrar','servicios_aportes','aportes_cuentas','archivo_retiros'],
        description: 'si es visible',
        label: 'View',
        readonly: true,
        type: 'boolean',
        datatype: 
        {
          type: 'check', 
          disabled: false,
          predeterminate: 0,
        }
      },
      nota_delete: {
        type: "text",
        label: "Nota",
        placeholder: "",
        namepath: [''],
        description: "",
        validate: "required",
        datatype: {
          type: "input",
          disabled: false,
          predeterminate: null
        }
      },
    }    
  }
}
